import React from "react";
import "./Logo.css";

const Logo = ({ className = "" }) => {
    return (
        <div className={`logo ${className}`}>
            <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="logo__icon"
            >
                <rect width="36" height="36" rx="7" fill="url(#ks-gradient)" />
                <text
                    x="18"
                    y="24"
                    textAnchor="middle"
                    className="logo__svg-text"
                >
                    KS
                </text>
                <defs>
                    <linearGradient
                        id="ks-gradient"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                    >
                        <stop offset="0%" stopColor="#3b82f6" />
                        <stop offset="100%" stopColor="#0ea5e9" />
                    </linearGradient>
                </defs>
            </svg>
            <span className="logo__name">Kyle Street</span>
        </div>
    );
};

export default Logo;
